import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { IEstadoCvNotifStoreItem, IValoresBusqueda } from 'src/model/candidato-api'
import { BusquedaCV, Condicion } from '../../model/busqueda-cv'

class PreguntaBusquedaComponentCtrl {
  busqueda!: BusquedaCV
  condicion!: Condicion
  datosTipos!: TiposDocEstadosStore | undefined
  titlepreg!: string
  onDeleteCond: () => void
  onChangeCond: () => void

  titleFilter: string

  valores: IValoresBusqueda
  statesList: IEstadoCvNotifStoreItem[]

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PreguntaBusquedaComponentCtrl] onInit')

    this.statesList = this.datosTipos?.estadosStore().list || []
    this.titleFilter = this.titlepreg || 'Filter'

    if (this.condicion.pregform) {
      this.seleccionaPreg()
    }
  }

  $postLink() {
    this.$timeout(() => {
      // (this.$element.find('select') as any).formSelect();
      // (this.$element.find('.datepicker') as any).datepicker({ autoClose: true, showClearBtn: true, firstDay: 1 });
    }, 200)
  }

  cambioPreg() {
    this.seleccionaPreg()

    this.onChangeCond()
  }

  seleccionaPreg() {
    // obtener las preguntas del formulario
    this.AccesoDatos.GestionCurr_CLIENT.valoresParaSeleccion(
      this.busqueda.idform,
      this.condicion.pregform.qf.idformq,
      this.condicion.pregform.q.idquest
    ).then((valoresResponse) => {
      this.$log.info('Valores posibles', valoresResponse)
      this.valores = valoresResponse

      this.$postLink()
    })
  }
}

angular.module('candidato').component('preguntaBusqueda', {
  bindings: {
    busqueda: '<',
    titlepreg: '@',
    condicion: '<',
    datosTipos: '<',
    onChangeCond: '&',
    onDeleteCond: '&',
  },
  controller: PreguntaBusquedaComponentCtrl,
  // templateUrl: "pregunta-busqueda.component.html",
  template: require('./pregunta-busqueda.component.html'),
})
